import { type MouseEvent } from "react";
import { IconButton, Tooltip } from "@radix-ui/themes";
import { IconStar, IconStarFilled } from "@tabler/icons-react";
import useUser from "@/lib/useUser";
import { setFavoriteCampaign } from "@/services/campaign";

interface Props {
  campaignId: number;
  size?: "1" | "2";
}

export default function CampaignFavoriteButton({
  campaignId,
  size = "2",
}: Props) {
  const { user, mutateUser } = useUser();
  const isFavorite = user?.favoriteCampaignId === campaignId;
  const iconSize = size === "1" ? 16 : 20;
  const label = isFavorite ? "Remove home favorite" : "Set as home favorite";

  const toggleFavorite = async (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();

    const nextFavoriteId = isFavorite ? null : campaignId;

    await mutateUser(
      (current: any) =>
        current
          ? {
              ...current,
              metadata: {
                ...current.metadata,
                favoriteCampaignId: nextFavoriteId,
              },
            }
          : current,
      { revalidate: false },
    );

    try {
      await setFavoriteCampaign(nextFavoriteId);
    } catch {
      await mutateUser();
    }
  };

  return (
    <Tooltip content={label}>
      <IconButton
        variant="ghost"
        color="amber"
        size={size}
        aria-label={label}
        onClick={toggleFavorite}
      >
        {isFavorite ? (
          <IconStarFilled size={iconSize} />
        ) : (
          <IconStar size={iconSize} />
        )}
      </IconButton>
    </Tooltip>
  );
}
